import classNames from 'classnames';
import React from 'react';
import { Link } from 'react-scroll';

interface BookButtonProps {
  buttonClass?: string;
  type: 'book' | 'partner';
  onClickHandler: (buttonType: 'book' | 'partner') => void;
  buttonText: string;
}

export const BookButton = ({ buttonClass, type, onClickHandler, buttonText }: BookButtonProps) => {
  return (
    <Link
      to="contact-form-container"
      className={classNames('book-button button-font', buttonClass)}
      spy
      smooth
      duration={300}
      onClick={() => onClickHandler(type)}
    >
      <span>{buttonText}</span>
    </Link>
  );
};
